








































module.exports = {
  "accordion":   {
    "accordion": () => import("../accordion/accordion.js")
  },
  "forms":   {
    "forms": () => import("../forms/forms.js")
  },
  "gallery":   {
    "gallery": () => import("../gallery/gallery.js")
  },
  "global-map":   {
    "constants": () => import("../global-map/constants.js"),
    "icons": () => import("../global-map/icons.js"),
    "index": () => import("../global-map/index.js"),
    "map-style": () => import("../global-map/map-style.js"),
    "signals": () => import("../global-map/signals.js")
  },
  "hero":   {
    "hero-video": () => import("../hero/hero-video.js")
  },
  "search-results":   {
    "instantsearch": () => import("../search-results/instantsearch.js"),
    "search-results": () => import("../search-results/search-results.js"),
    "widgets": () => import("../search-results/widgets.js")
  },
  "slideout":   {
    "slideout": () => import("../slideout/slideout.js"),
    "state": () => import("../slideout/state.js"),
    "utils": () => import("../slideout/utils.js")
  },
  "slider":   {
    "slider-plugins": () => import("../slider/slider-plugins.js"),
    "card-slider":     {
      "card-slider": () => import("../slider/card-slider/card-slider.js")
    },
    "related-item-slider":     {
      "related-item-slider": () => import("../slider/related-item-slider/related-item-slider.js")
    },
    "review-item-slider":     {
      "review-item-slider": () => import("../slider/review-item-slider/review-item-slider.js")
    }
  },
  "slideup":   {
    "slideup": () => import("../slideup/slideup.js")
  },
  "tab":   {
    "tab": () => import("../tab/tab.js")
  },
  "visitor-pass":   {
    "index": () => import("../visitor-pass/index.js")
  },
  "header":   {
    "search":     {
      "search": () => import("../header/search/search.js")
    },
    "nav-primary":     {
      "nav-primary": () => import("../header/nav-primary/nav-primary.js")
    }
  }
}